/*eslint-disable*/
import React from 'react'
import { Input, Form } from 'semantic-ui-react'

export const MyInput = ({
    field,
    ...props
}) => (
    <>
        <Form.Input

            {...field}
            {...props}
        />
    </>
)
export const MyNormalInput = ({
    field,
    ...props
}) => (
    <>
        <Input

            {...field}
            {...props}
        />

    </>
)

export const MyCheckBox = ({
    field,
    ...props
}) => (
    <>
        <Form.Checkbox {...field} {...props} />
    </>
)
export const MyTextArea = ({
    field,
    ...props
}) => (
    <>
        <Form.TextArea style={{ width: '100%', resize: 'none' }} {...field} {...props} />
    </>
)
